import { useMemo, useState } from "react";
import { Card, SectionHeader, TextInput } from "../../components/lib";
import { TabBar, ListRow } from "../../components/lib.overlay";
import { AUDIT_LOG, AuditEntry } from "../../mocks/workspaceData";

const SEV_META: Record<AuditEntry["severity"], { bg: string; fg: string }> = {
  info:     { bg: "var(--ph-neutral-tint)", fg: "var(--ph-ink-muted)" },
  warn:     { bg: "var(--ph-warning-tint)", fg: "var(--ph-warning)"   },
  critical: { bg: "var(--ph-danger-tint)",  fg: "var(--ph-danger)"    },
};

export default function AuditLog() {
  const [tab, setTab] = useState<AuditEntry["severity"] | "all">("all");
  const [q, setQ] = useState("");
  const filtered = useMemo(() => AUDIT_LOG.filter((e) =>
    (tab === "all" || e.severity === tab) &&
    (!q || e.actor.toLowerCase().includes(q.toLowerCase()) || e.target.toLowerCase().includes(q.toLowerCase()) || e.action.toLowerCase().includes(q.toLowerCase())),
  ), [tab, q]);

  return (
    <div className="space-y-6" data-testid="ws-audit">
      <Card testId="ws-a-filters">
        <TextInput value={q} onChange={setQ} placeholder="Search audit log by actor, action or target…" testId="ws-a-search" />
        <div className="mt-4">
          <TabBar<AuditEntry["severity"] | "all">
            testId="ws-a-tabs"
            active={tab}
            onChange={setTab}
            tabs={[
              { key: "all",      label: "All"      },
              { key: "critical", label: "Critical" },
              { key: "warn",     label: "Warnings" },
              { key: "info",     label: "Info"     },
            ]}
          />
        </div>
      </Card>

      <Card padded={false} testId="ws-a-list-card">
        <div className="p-5" style={{ borderBottom: "1px solid var(--ph-border-subtle)" }}>
          <SectionHeader eyebrow="Audit" title={`${filtered.length} event${filtered.length === 1 ? "" : "s"}`} />
        </div>
        <div className="p-2">
          {filtered.map((e) => {
            const m = SEV_META[e.severity];
            return (
              <ListRow key={e.id} testId={`ws-au-${e.id}`}
                label={<span className="inline-flex items-center gap-2">{e.actor} · <span style={{ color: "var(--ph-ink-muted)" }}>{e.action}</span> · {e.target}
                  <span className="px-1.5 py-0.5 text-[9px] font-semibold uppercase" style={{ letterSpacing: "0.14em", background: m.bg, color: m.fg, borderRadius: "var(--ph-radius-sm)" }}>{e.severity}</span>
                </span>}
                sublabel={<>{e.module} · {e.whenRelative}</>}
              />
            );
          })}
        </div>
      </Card>
    </div>
  );
}
